import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ACTION_TYPE from '../../../store/ACTION_TYPE';

const PassChildren = (props) => {
    if (props[props.platformChoice] === false) {
        if (props.fallback) {
            const Fallback = props.fallback; // jsx <3

            return <Fallback />;
        }

        return null;
    }

    return props.children || null;
};

PassChildren.propTypes = {
    platformChoice: PropTypes.string.isRequired,
    fallback: PropTypes.elementType,
    children: PropTypes.node,
};

const PassChildrenWrapper = (platformChoice) =>
    connect((state) => ({
        connect: state.user.connectSession,
        protect: state.user.protectSession,
        platformChoice,
    }))(PassChildren);

export const RequiresConnect = PassChildrenWrapper('connect');
export const RequiresProtect = PassChildrenWrapper('protect');

export function selectPlatformByQuery() {
    const queryParams = new URLSearchParams(window.location.search);
    const platform = queryParams.get('platform');
    if (platform === 'connect' || platform === 'protect') {
        return {
            type: ACTION_TYPE.SET_STATE_QUERY_PARAM_PLATFORM,
            platform,
        };
    }

    return { type: 'nothing' };
}

export const storage = {
    platformId: '',
};

export function selectPlatformIdByQuery() {
    const queryParams = new URLSearchParams(window.location.search);
    const platformId = queryParams.get('platformId');
    if (platformId) {
        storage.platformId = platformId;
    }
}
